import { gql } from '@apollo/client';

export const globalSearchQuery = gql`
    query globalSearchQuery($startIndex: Int!, $stopIndex: Int!, $dataType: String, $text: String, $filterBy: [JSON]) {
        globalSearch(startIndex: $startIndex, stopIndex: $stopIndex, dataType: $dataType, text: $text, filterBy: $filterBy) {
            totalCount
            hasMore
            results {
                score
                item {
                    __typename
                    ... on Entity {
                        id
                        name
                        type
                        image
                        createdDate
                        iconName
                        iconColor
                        iconType
                    }
                    ... on Task {
                        id
                        name
                        type
                        image
                        createdDate
                        iconName
                        iconColor
                        iconType
                        description
                        modifiedDate
                        modifiedBy {
                            id
                            name
                            image
                        }
                        createdBy {
                            id
                            name
                            image
                        }
                        assignee {
                            id
                            username
                            name
                            image
                        }
                        active
                    }
                    ... on Process {
                        id
                        name
                        type
                        image
                        createdDate
                        iconName
                        iconColor
                        iconType
                        description
                        modifiedDate
                        modifiedBy {
                            id
                            name
                            image
                        }
                        createdBy {
                            id
                            name
                            image
                        }
                        active
                    }
                    ... on Workspace {
                        id
                        name
                        category
                        active
                        isSystem
                        createdDate
                        createdBy {
                            id
                            name
                        }
                        modifiedDate
                        modifiedBy {
                            id
                            name
                        }
                    }
                    ... on Team {
                        id
                        name
                        category
                        active
                        isSystem
                        createdDate
                        createdBy {
                            id
                            name
                        }
                        modifiedDate
                        modifiedBy {
                            id
                            name
                        }
                    }
                }
            }
        }
    }
`;

